<nav class="main-header navbar navbar-expand-md navbar-dark navbar-gray-dark">
  <div class="container-fluid">

    <a [routerLink]="lnkDashboard" class="navbar-brand">
      <img src="assets/img/logoVMS.png" alt="Logo" class="brand-image devcare-logo">
      <!-- <span class="brand-text font-weight-light devcare-text d-none d-md-inline">VMS</span> -->
      <!-- <span class="brand-text font-weight-light devcare-text d-md-none">D-VMS</span> -->
    </a>
    <button *ngIf="show" class="navbar-toggler order-0" type="button" data-widget="pushmenu" style="font-size: 14px;">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- <div class="collapse navbar-collapse order-3" id="navbarCollapse" *ngIf="show"> -->
      <div class="collapse navbar-collapse order-3" id="navbarCollapse" *ngIf="show">
      <!-- Left top navbar links -->
      <ul class="navbar-nav mr-auto devcare-nav">
        <li *ngIf="isAdminMenuVisible" class="nav-item active">
          <a [routerLink]="['/dashboard/admin']" class="nav-link">
            <i class="nav-icon fas fa-home dev-icon"></i>&nbsp;
            <span class="devcare-nav-text">Home</span>
          </a>
        </li>
        <li *ngIf="!isAdminMenuVisible" class="nav-item active">
          <a [routerLink]="['/dashboard/vendor']" class="nav-link">
            <i class="nav-icon fas fa-home dev-icon"></i>&nbsp;
            <span class="devcare-nav-text">Home</span>
          </a>
        </li>
        <li class="nav-item dropdown" *ngIf="sharedService.checkPermission('Applicant_View')">
          <a id="dropdownSubMenu1" [routerLink]="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            class="nav-link dropdown-toggle"><i class="pi pi-user dev-icon"></i> &nbsp;<span
              class="devcare-nav-text">Applicants</span></a>
          <ul aria-labelledby="dropdownSubMenu1" class="dropdown-menu border-0 shadow">
            <!-- <li *ngIf="sharedService.checkPermission('Applicant_Add') && !sharedService.isMspUser()"><a [routerLink]="['/applicant/applicant-add']" class="dropdown-item">Add Applicant</a></li> -->
            <li *ngIf="sharedService.checkPermission('Applicant_View')"><a [routerLink]="['/applicant/applicant-search']" class="dropdown-item">Submitted Applicant Search</a></li>
            <!-- <li *ngIf="sharedService.checkPermission('Applicant_View')"><a [routerLink]="['/applicant/applicant-old-search']" class="dropdown-item">Applicant Search old</a></li> -->
          </ul>
        </li>
        <li class="nav-item dropdown" *ngIf="sharedService.checkPermission('Requisition_View')">
          <a id="dropdownSubMenu1" [routerLink]="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            class="nav-link dropdown-toggle"><i class="pi pi-briefcase dev-icon"></i> &nbsp;<span
              class="devcare-nav-text">Requisitions</span></a>
          <ul aria-labelledby="dropdownSubMenu1" class="dropdown-menu border-0 shadow">
            <li *ngIf="sharedService.checkPermission('Requisition_View')"><a [routerLink]="['/requisition/requisition-search']" class="dropdown-item">Requisition Search</a></li>
            <!-- <li *ngIf="sharedService.checkPermission('Submission_Add')"><a [routerLink]="['/requisition/submission','AB12345669']" class="dropdown-item">Requisition Submission</a></li> -->
          </ul>
        </li>
        <!-- <li class="nav-item dropdown">
          <a id="dropdownSubMenu1" [routerLink]="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            class="nav-link dropdown-toggle"><i class="fas fa-bullseye dev-icon"></i> &nbsp;<span
              class="devcare-nav-text">Submission</span></a>
          <ul aria-labelledby="dropdownSubMenu1" class="dropdown-menu border-0 shadow">
            <li><a [routerLink]="['/datatable']" class="dropdown-item">Requirment Submission</a></li>
          </ul>
        </li> -->
        <!-- <li class="nav-item dropdown">
          <a id="dropdownSubMenu1" [routerLink]="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            class="nav-link dropdown-toggle"><i class="fas fa-briefcase dev-icon"></i> &nbsp;<span
              class="devcare-nav-text">Engagement</span></a>
          <ul aria-labelledby="dropdownSubMenu1" class="dropdown-menu border-0 shadow">
            <li><a [routerLink]="['/datatable']" class="dropdown-item">Search Engagement</a></li>
          </ul>
        </li> -->

        <!-- <li  *ngIf="!isVendorUser" class="nav-item dropdown">
          <a  id="dropdownSubMenu1" [routerLink]="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            class="nav-link dropdown-toggle"><i class="pi pi-dollar dev-icon"></i> &nbsp;<span
              class="devcare-nav-text">Invoices</span></a>
          <ul aria-labelledby="dropdownSubMenu1" class="dropdown-menu border-0 shadow">
            <li *ngIf="!isAdminMenuVisible"><a [routerLink]="['/invoice/vendor']" class="dropdown-item">Invoice Search</a></li>
            <li *ngIf="isAdminMenuVisible && sharedService.checkPermission('Admin_View')"><a [routerLink]="['/invoice/admin']" class="dropdown-item">Invoice Search</a></li>
          </ul>
        </li> -->

        <li class="nav-item dropdown" *ngIf="sharedService.checkPermission('Invoice_View')">
          <a  id="dropdownSubMenu1" [routerLink]="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            class="nav-link dropdown-toggle"><i class="pi pi-dollar dev-icon"></i> &nbsp;<span
              class="devcare-nav-text">Invoices</span></a>
          <ul aria-labelledby="dropdownSubMenu1" class="dropdown-menu border-0 shadow">
            <li *ngIf="!isAdminMenuVisible && sharedService.checkPermission('Invoice_View')"><a [routerLink]="['/invoice/vendor']" class="dropdown-item">Invoice Search</a></li>
            <li *ngIf="isAdminMenuVisible && sharedService.checkPermission('Invoice_View')"><a [routerLink]="['/invoice/admin']" class="dropdown-item">Invoice Search</a></li>
          </ul>
        </li>

        <!-- <li class="nav-item dropdown">
          <a id="dropdownSubMenu1" [routerLink]="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            class="nav-link dropdown-toggle"><i class="far fa-file-alt dev-icon"></i> &nbsp;<span
              class="devcare-nav-text">Reports</span></a>
          <ul aria-labelledby="dropdownSubMenu1" class="dropdown-menu border-0 shadow">
            <li><a [routerLink]="['/candidate']" class="dropdown-item">Requisition</a></li>
            <li><a [routerLink]="['/candidate-add']" class="dropdown-item">Interview</a></li>
            <li><a [routerLink]="['/candidate-add']" class="dropdown-item">Placement</a></li>
          </ul>
        </li> -->
        <li class="nav-item dropdown" *ngIf="sharedService.checkPermission('User_View')">
          <a id="dropdownSubMenu1" [routerLink]="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            class="nav-link dropdown-toggle"><i class="pi pi-users dev-icon"></i> &nbsp;<span
              class="devcare-nav-text">Users</span></a>
          <ul aria-labelledby="dropdownSubMenu1" class="dropdown-menu border-0 shadow">
            <li *ngIf="isUserMenuVisible && sharedService.checkPermission('User_Add')"><a [routerLink]="['/users/create-user']" class="dropdown-item">Create User </a></li>
             <!-- <li><a [routerLink]="['/users/import-user']" class="dropdown-item">Import User </a></li>  -->
            <li *ngIf="isUserMenuVisible  && sharedService.checkPermission('User_View')"><a [routerLink]="['/users/user-search']" class="dropdown-item">User Search </a></li>
            <!-- <li *ngIf="isAdminMenuVisible && sharedService.checkPermission('Admin_View')"><a [routerLink]="['/users/company-search']" class="dropdown-item">Vendor Search </a></li> -->
            <li *ngIf="isUserMenuVisible && sharedService.checkPermission('User_View')"><a [routerLink]="['/users/user-permissions']" class="dropdown-item">User Permissions </a></li>
            <li><a [routerLink]="['/users/vendor-view']" class="dropdown-item">Company Profile</a></li>
            <li *ngIf="!isSuperAdminVisible"><a [routerLink]="['/users/change-password']" class="dropdown-item">Change Password</a></li>
            <!-- <li *ngIf="sharedService.checkPermission('User_Add')"><a [routerLink]="['/users/dvms-improvements']" class="dropdown-item">DVMS Improvements</a></li> -->

          </ul>
        </li>
        <li class="nav-item dropdown" *ngIf="isAdminMenuVisible && sharedService.checkPermission('Admin_View')">
          <a id="dropdownSubMenu1" [routerLink]="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            class="nav-link dropdown-toggle"><img class="mt-n1" src="../../../../assets/img/employees.png" width="17px" height="18px" alt=""> &nbsp;<span
              class="devcare-nav-text">Vendors</span></a>
          <ul aria-labelledby="dropdownSubMenu1" class="dropdown-menu border-0 shadow">
            <li><a [routerLink]="['/admin/client-approval-search']" class="dropdown-item"> Client Approval </a></li> 
            <li><a [routerLink]="['/admin/create-vendor']" class="dropdown-item">Create Vendor</a></li> 
            <li *ngIf="sharedService.checkPermission('Applicant_Add')"><a [routerLink]="['/admin/import-invoice-applicant']" class="dropdown-item">Import Invoice Applicant</a></li>         
            <li><a [routerLink]="['/admin/vendor-approval-search']" class="dropdown-item">Vendor Approval </a></li>         
            <li><a [routerLink]="['/admin/vendor-client-assignment']" class="dropdown-item">Vendor Client Assignment</a></li>         
            <li><a [routerLink]="['/admin/vendor-profile-status']" class="dropdown-item"> Vendor Profile Status </a></li>         
            <li *ngIf="isAdminMenuVisible && sharedService.checkPermission('Admin_View')"><a [routerLink]="['/users/vendor-search']" class="dropdown-item">Vendor Search </a></li>
            <li *ngIf="isAdminMenuVisible && sharedService.checkPermission('Admin_View')"><a [routerLink]="['/admin/dvms-system-alerts']" class="dropdown-item">DVMS System Alerts </a></li>
            <li *ngIf="isSuperAdminVisible && isRateApporvalMenuVisible"><a [routerLink]="['/admin/rate-change-request']" class="dropdown-item">Rate Change Request</a></li>
            <li><a [routerLink]="['/admin/vendor-onboarding']" class="dropdown-item">Vendor Onboarding</a></li>
            <li *ngIf="isSuperAdminVisible && isVendorOnboardProcessSearchMenuVisible"><a [routerLink]="['/admin/vendor-onboard-process-search']" class="dropdown-item">Vendor Onboard Process Search</a></li>
            <li *ngIf="isSuperAdminVisible"><a [routerLink]="['/admin/vendor-onboard-approval-search']" class="dropdown-item">Vendor Onboard Approval Search</a></li>                  
          </ul>
        </li>
        <li class="nav-item dropdown" *ngIf="isAdminMenuVisible   && sharedService.checkPermission('Admin_View')">
          <a id="dropdownSubMenu1" [routerLink]="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            class="nav-link dropdown-toggle"><i class="pi pi-cog dev-icon"></i> &nbsp;<span
              class="devcare-nav-text">Admin</span></a>
          <ul aria-labelledby="dropdownSubMenu1" class="dropdown-menu border-0 shadow" style="width:510px;">
            <li>
              <div class="row p-d-flex p-jc-between">
                <div class="col-6 col-3"><a [routerLink]="['/admin/application-features']" class="dropdown-item">Application Features </a></div>
                <div class="col-6 col-3"><a [routerLink]="['/admin/application-claim-types']" class="dropdown-item">Application Claim Types </a></div>
              </div>
            </li>
            <li>
              <div class="row p-d-flex p-jc-between">
                <div class="col-6 col-3"><a [routerLink]="['/admin/user-role-default-features']" class="dropdown-item text-left">User Role Default Features </a></div>
                <div class="col-6 col-3"><a [routerLink]="['/admin/claims-master']" class="dropdown-item text-left">Claims Master </a></div>
              </div>
            </li>  
            <li>
              <div class="row p-d-flex p-jc-between">
                <div class="col-6 col-3"><a [routerLink]="['/admin/user-claims']" class="dropdown-item">User Claims </a></div>
                <div class="col-6 col-3"><a [routerLink]="['/admin/lookup-category']" class="dropdown-item">Lookup Category </a></div>
              </div>
            </li>  
            <li>
              <div class="row p-d-flex p-jc-between">
                <div class="col-6 col-3"><a [routerLink]="['/admin/lookup-master']" class="dropdown-item">Lookup Master </a></div>
                <div class="col-6 col-3"><a [routerLink]="['/admin/email-template']" class="dropdown-item">Email Template </a></div>
              </div>
            </li>  
            <li>
              <div class="row p-d-flex p-jc-between">
                <div class="col-6 col-3"><a [routerLink]="['/admin/state']" class="dropdown-item">State </a></div>
                <div class="col-6 col-3"><a [routerLink]="['/admin/city']" class="dropdown-item">City </a></div>
              </div>
            </li> 
            <li>
              <div class="row p-d-flex p-jc-between">
                <div class="col-6 col-3"><a [routerLink]="['/admin/country']" class="dropdown-item">Country </a></div>
                <div class="col-6 col-3" ><a [routerLink]="['/admin/client-master']" class="dropdown-item">Client Master</a></div>
              </div>
            </li>              
            <li>
              <div class="row p-d-flex p-jc-between">
                <div class="col-6 col-3"><a [routerLink]="['/admin/client-requisition-contact']" class="dropdown-item">Client Requisition Contact</a></div>
                <div class="col-6 col-3"><a [routerLink]="['/admin/email-configuration']" class="dropdown-item">Email Smtp Configuration</a></div>
              </div>
            </li>
            <li>
              <div class="row p-d-flex p-jc-start">
                <div class="col-6 col-3"><a [routerLink]="['/admin/client-checklist']" class="dropdown-item">Client Checklist</a></div>   
                <div class="col-6 col-3"><a [routerLink]="['/admin/search-page-theme']" class="dropdown-item">Search Page Theme</a></div>             
                <!-- <div class="col-6 col-3"><a [routerLink]="['/admin/send-email']" class="dropdown-item">Send Email</a></div> -->
              </div>
            </li>
            <li>
              <div class="row p-d-flex p-jc-start">
                <div class="col-6 col-3"><a [routerLink]="['/admin/search-page-columns']" class="dropdown-item">Search Page Columns</a></div>   
                <div class="col-6 col-3"><a [routerLink]="['/admin/search-themecolumns-assign']" class="dropdown-item">Search Theme Columns Assign</a></div>             
              </div>
              <!-- <div class="row p-d-flex p-jc-left">
                <div class="col-6 col-3"><a [routerLink]="['/admin/import-invoice-applicant']" class="dropdown-item">Import Invoice Applicant</a></div>
                <div class="col-6 col-3"><a [routerLink]="['/admin/create-vendor']" class="dropdown-item">Create Vendor</a></div>
              </div> -->
            </li>
            <li>
              <div class="row p-d-flex p-jc-start">
                <div class="col-6 col-3"><a [routerLink]="['/admin/search-themeusers-assign']" class="dropdown-item">Search Theme Users Assign</a></div>   
                <div class="col-6 col-3"><a [routerLink]="['/admin/document-template']" class="dropdown-item">Document Template </a></div>
                <!-- <div class="col-6 col-3"><a [routerLink]="['/admin/search-themecolumns-assign']" class="dropdown-item">Search ThemeColumns Assign</a></div>              -->
              </div>
            </li>
            <li>
              <div class="row p-d-flex p-jc-start">
                <div class="col-6 col-3"><a [routerLink]="['/admin/email-channel']" class="dropdown-item">Email Channel</a></div>
                <!-- <div class="col-6 col-3"><a [routerLink]="['/admin/search-themecolumns-assign']" class="dropdown-item">Search ThemeColumns Assign</a></div>              -->
              </div>
            </li>
          </ul>
        </li>

        <li class="nav-item dropdown" *ngIf="isAdminMenuVisible   && sharedService.checkPermission('Admin_View')">
          <a id="dropdownSubMenu1" [routerLink]="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            class="nav-link dropdown-toggle"><img src="../../../../assets/img/report.png" width="20px" height="20px"> &nbsp;<span
              class="devcare-nav-text">Reports</span></a>
          <ul aria-labelledby="dropdownSubMenu1" class="dropdown-menu border-0 shadow">
            <li><a [routerLink]="['/report/vendor-activity']" class="dropdown-item"> Vendor Activity </a></li>
            <li><a [routerLink]="['/report/vendor-invoices']" class="dropdown-item"> Vendor Invoices </a></li>
            <li><a [routerLink]="['/report/user-activity-log']" class="dropdown-item"> User Activity Log </a></li>
            <li><a [routerLink]="['/report/email-delivery-report']" class="dropdown-item"> Email Delivery Report </a></li>
            <li><a [routerLink]="['/report/error-log']" class="dropdown-item"> Error Log </a></li>

          </ul>
        </li>     
        <li class="nav-item dropdown" *ngIf="sharedService.checkPermission('User_View')">
          <a id="dropdownSubMenu1" [routerLink]="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            class="nav-link dropdown-toggle">
            <img src="../../../../assets/img/statistics.png" width="15px" height="15px">
             &nbsp;<span
              class="devcare-nav-text">DVMS Improvements</span></a>
          <ul aria-labelledby="dropdownSubMenu1" class="dropdown-menu border-0 shadow">
            <li *ngIf="sharedService.checkPermission('User_View')"><a [routerLink]="['/users/dvms-improvements']" class="dropdown-item">Improvements Search</a></li>             
          </ul>
        </li>    
      </ul>

    </div>

    <!-- Right top navbar links -->

    <!-- <ul class="order-1 order-md-3 navbar-nav navbar-no-expand ml-auto" *ngIf="show"> -->
      <ul class="order-1 order-md-3 navbar-nav navbar-no-expand ml-auto" *ngIf="show">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item dropdown user-menu">
          <a [routerLink]="" class="nav-link dropdown-toggle" data-toggle="dropdown">
            <!-- <img src="assets/img/user-icon.png" class="user-image img-circle elevation-2" alt="User Image"> -->
            <!-- <span class="d-none d-md-inline devcare-user-menu">{{profileUserName}}</span> -->
            <span class="user-image text-center font-weight-bold img-circle elevation-2" alt="User Image" style="font-size:20px;padding:10px; border: 2px solid white;" > 
              {{firstName[0] | uppercase}} {{lastName[0]  | uppercase}}
            </span>
          </a>
          <ul class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
            <!-- User image -->
            <li class="user-header" style="height:auto !important;">
              <div style="height: 50px;background-color: cornflowerblue;">

              </div>
              <!-- <img src="assets/img/user-icon.png" class="img-circle elevation-2" alt="User Image" style="margin-top: -40px;border-color: white;"> -->
              <div style="margin-top:-15px;">
                <span class="text-center font-weight-bold border border-rounded p-p-2 text-info usericon"> 
                  {{firstName[0] | uppercase}} {{lastName[0]  | uppercase}}
                </span>
              </div>
              <p style="word-wrap:break-word !important;height:auto !important;margin-top:15px;">
                {{profileUserName}}
                <small>{{role}}</small>
              </p>
            </li>
            <li class="p-d-flex p-jc-between p-mb-1 p-p-2" style="background-color: aliceblue;">
              <div class="text-left">
              <button  [routerLink]="['/users/my-profile']" type="button" class="btn btn-5" value="Profile">Profile</button>                
              </div>
              <div class="text-right">
              <button type="button" class="btn btn-5" value="Profile" (click)="onLogout()">Logout</button>                
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </ul>
  </div>
</nav>